import { getToken, getExpirationDate } from "./user";
import axios from 'axios'

const http = url => {

    const config = getConfig();
    const _url = `${config.url_api}${url}`;

    

    const base = (url, props) => {

        const { mustAuth } = props;

        return new Promise((resolve, reject) => {

            const token = getToken();
            let headers = {
                method: 'GET',
            }

            if (mustAuth && token) headers = { ...headers, 'Authorization': `Bearer ${token}` };

            fetch(url, { ...props, headers })
                .then(processResponse)
                .then(response => resolve(response))
                .catch(err => reject(err));

        })
    }



    const baseFetch = (url, method, data, { mustAuth }) => {

        const token = getToken();

        let headers = {
            method: method,
            'Content-Type': 'application/json',
        }

        const dataBody = data ? JSON.stringify(data) : data;

        if (mustAuth && token) headers = { ...headers, 'Authorization': `Bearer ${token}` };

        return new Promise((resolve, reject) => {
            fetch(url, {
                method: method,
                body: dataBody,
                headers: { ...headers }
            })
                .then(processResponse)
                .then(response => resolve(response))
                .catch(err => reject(err));
        })
    }

    const getQueryString = data => {

        let queryString = '';

        if (data) {

            let parameters = typeof data === 'function' ? data() : data;

            for (let key in parameters)
                queryString += `&${key}=${parameters[key]}`;

        }

        return queryString;

    }

    return {
        get: data => {
            let params = getQueryString(data);
            return base(`${_url}?${params}`, { mustAuth: true });
        },
        getWithoutParam: data => {
            return base(`${_url}`, { mustAuth: true });
        },
        getWithParam: data => {
            return base(`${_url}?${data}`, { mustAuth: true });
        },
        getOutWithAuth: data => {
            let params = getQueryString(data);
            return base(`${_url}?${params}`, { mustAuth: false });
        },
        post: (data) => baseFetch(_url, 'POST', data, { mustAuth: true }),
        postOutWithAuth: data => baseFetch(_url, 'POST', data, { mustAuth: false }),
        put: (data) => baseFetch(_url, 'PUT', data, { mustAuth: true }),
        file: files => {

            let formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('documentos', files[i]);
            }

            fetch(_url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                body: formData
            });
        },
        multipleFile: files => {

            var formData = new FormData();
            for (let i = 0; i < files.Adjunto.length; i++) {
                formData.append('file', files.Adjunto[i], files.filename);
            }


            return new Promise((resolve, reject) => {

                /*  fetch(_url, {
                       method: 'POST',
                       headers: {
                           'Authorization': `Bearer ${getToken()}`
                       },
                       body: formData
                   })
                   .then(processResponse)
                   .then(response => resolve(response))
                   .catch(err => reject(err));    */

                let config = {
                    headers: {
                        'Authorization': 'Bearer ' + getToken()
                    }
                }

                axios.postForm(_url, formData, config).then(processResponse)
                    .then(response => resolve(response))
                    .catch(err => {
                        console.log(err);
                        reject(err)
                    });
            });

        },
        multipleFileData: (data, files = []) => {
            var formData = new FormData();

            for (const key in data)
                formData.append(key, data[key]);
            files.map((element, index) => formData.append('files', element, element.name))

            return new Promise((resolve, reject) => {
                let config = {
                    headers: {
                        'Authorization': 'Bearer ' + getToken()
                    }
                }

                axios.postForm(_url, formData, config)
                    .then(response => resolve(response.data))
                    .catch(err => {
                        console.log(err);
                        reject(err)
                    });

            });

        }
    }

}



const downloadFile = (response, resolve) => {
    let filename = 'Oferta.pdf';

    let disposition = response.headers.get('Content-Disposition');

    if (disposition && disposition.indexOf('attachment') !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
    }

    if (filename == '')
        filename = `Docuement${new Date().getTime()}.pdf`;

    response.blob().then(blob => {

        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(blob, filename);
        } else {
            var URL = window.URL || window.webkitURL;
            var downloadUrl = URL.createObjectURL(blob);

            if (filename) {
                var a = document.createElement("a");
                if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
            } else {
                window.location = downloadUrl;
            }

            setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 1000); // cleanup
        }

        resolve();
    });

}

/**
 * Procesa los http response
 * @param {Promise} response
 * @return {Promise} 
 */
const processResponse = response => {

    return new Promise((resolve, reject) => {


        if (response.status === httpStatus.badRequest)
            response.text().then(err => reject(err));

        if (response.status === httpStatus.notFound)
            response.text().then(err => reject(err));

        if (response.status === httpStatus.internalServerError)
            response.text().then(err => reject('Error interno en la aplicación'));

        if (response.status === httpStatus.ok) {
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                // process your JSON data further
                response.json().then(data => resolve(data));
            } else if (contentType && contentType.toLowerCase().indexOf("application/pdf") !== -1) {
                downloadFile(response, resolve);
            }
            else {
                // this is text, do something with it
                response.text().then(data => resolve({ message: data }));
            }
        }
    })
}


const httpStatus = {
    ok: 200,
    badRequest: 400,
    unauthorized: 401,
    forbidden: 403,
    notFound: 404,
    internalServerError: 500
}

export const getConfig = () => JSON.parse(localStorage.getItem('config'));

export const setConfig = async () => {

    const hostname = window.location.hostname;

    const isProductionNI = hostname.includes('seguronetnlb.seguroslafise.com.ni');
    const isProductionCR = hostname.includes('appscr.seguroslafise.com');
    const isProductionHN = hostname.includes('seguronethn.seguroslafise.com.ni');

    let config = {};

    if ([isProductionNI, isProductionCR, isProductionHN].includes(true)) {

        const resp = await fetch(`env.pro.json`);
        const data = await resp.json();

        if (isProductionNI) config = data['NI'];
        if (isProductionCR) config = data['CR'];
        if (isProductionHN) config = data['HN'];

    }

    const isPreproductionNI = hostname.includes('secure.seguroslafise.com.ni');
    const isPreproductionCR = hostname.includes('appscrpre.seguroslafise.com');
    const isPreproductionHN = hostname.includes('appshnpre.seguroslafise.com');


    if ([isPreproductionNI, isPreproductionCR, isPreproductionHN].includes(true)) {

        const resp = await fetch(`env.pre.json`);
        const data = await resp.json();

        if (isPreproductionNI) config = data['NI'];
        if (isPreproductionCR) config = data['CR'];
        if (isPreproductionHN) config = data['HN'];

    }

    const isLocal = hostname.includes('localhost');

    if (isLocal) {

        const resp = await fetch(`env.json`);
        const data = await resp.json();

        config = data['NI'] || data['CR'] || data['HN'];

    }

    localStorage.setItem('config', JSON.stringify(config));

};

export default http;